interface IconReviewStarGeneratorProps {
  size: number;
  color?: string;
  count?: number;
}

export function IconReviewStarGenerator({size = 24, color = '#FFAC11', count = 5}: IconReviewStarGeneratorProps) {
  const length = 5;
  const renderStar = (index: number) => {
    const deselected = '#0000001A';
    const fillColor = index < count
      ? color
      : deselected;
    return <svg
      key={IconReviewStarGenerator.toString()  + index}
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.38488 0.692677C8.68423 -0.228634 9.98764 -0.228635 10.287 0.692676L11.8056 5.36644C11.9395 5.77846 12.3234 6.05742 12.7566 6.05742H17.6709C18.6397 6.05742 19.0424 7.29704 18.2587 7.86644L14.283 10.755C13.9325 11.0096 13.7858 11.461 13.9197 11.873L15.4383 16.5468C15.7377 17.4681 14.6832 18.2342 13.8995 17.6648L9.92372 14.7763C9.57324 14.5216 9.09864 14.5216 8.74815 14.7763L4.77241 17.6648C3.9887 18.2342 2.93422 17.4681 3.23357 16.5468L4.75217 11.873C4.88604 11.461 4.73938 11.0096 4.3889 10.755L0.413159 7.86644C-0.370555 7.29704 0.0322201 6.05742 1.00094 6.05742H5.91523C6.34845 6.05742 6.73241 5.77846 6.86628 5.36644L8.38488 0.692677Z"
        fill={fillColor}
      />
    </svg>
  };

  return (
    <>
      {Array.from({ length }, (_, index) => renderStar(index))}
    </>
  );
}